/**
 * Created by Ning Jiang on 2023-12-12.
 */
import {WinPresentationController} from "../../WinPresentationController";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";
import {StageView} from "../../../view/StageView";
import {gsap} from "gsap";

export class PreBigWinController extends WinPresentationController {

    constructor() {
        super("PreBigWinController", false);
    }

    protected hasWin():boolean {
        return DevilsCrossRoad.model.gameData.nextMode === GameMode.NORMAL &&
            DevilsCrossRoad.model.gameData.accumulatedRoundWin > 0 &&
            DevilsCrossRoad.model.totalWinRatioConfig!.bigWinLevel > -1;
    }

    protected async createWinAnimation():Promise<any> {
        DevilsCrossRoadSound.fadeMusic(0, 200);
        DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.BIG_WIN_INTRO});
        DevilsCrossRoad.multipliers.dimAllMultipliers();
        DevilsCrossRoad.backgroundElements.setMainFrame("big_glow_fast", false);
        const tl = gsap.timeline();
        tl.add(StageView.getShakeStageOnceTl(2));
        tl.add(StageView.getShakeStageOnceTl(2));
        tl.add(StageView.getShakeStageOnceTl(1));
        tl.add(() => {}, "+=0.3");
        await tl;
    }
}